import React from 'react';
import Link from 'next/link';

export const SkeletonCard = () => (
  <div className="tw:animate-pulse tw:border tw:border-gray-200 tw:rounded-lg tw:overflow-hidden">
    <div className="tw:h-[200px] tw:bg-gray-200" />
    <div className="tw:p-4 tw:flex tw:flex-col tw:gap-3">
      <div className="tw:h-5 tw:bg-gray-200 tw:rounded tw:w-3/4" />
      <div className="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-1/2" />
      <div className="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-2/5 tw:mt-2" />
      <div className="tw:h-10 tw:bg-gray-200 tw:rounded tw:mt-4" />
    </div>
  </div>
);

interface CardGridProps {
  children: React.ReactNode;
}

export const CardGrid: React.FC<CardGridProps> = ({ children }) => (
  <ul className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:lg:grid-cols-3 tw:gap-6 tw:pl-0 tw:[&>*:nth-child(3)]:md:hidden tw:[&>*:nth-child(3)]:lg:block">
    {React.Children.map(children, (child) => {
      if (!child) return null;
      return <li className="tw:list-none tw:w-full">{child}</li>;
    })}
  </ul>
);

export interface RowLayoutProps {
  title: string;
  manageHref?: string;
  manageLabel?: string;
  children: React.ReactNode;
}

export const RowLayout: React.FC<RowLayoutProps> = ({
  title,
  manageHref,
  manageLabel,
  children,
}) => (
  <section className="tw:w-full">
    <div className="tw:flex tw:items-center tw:justify-between tw:mt-10 tw:mb-8">
      <h6 className="tw:text-md tw:font-normal tw:m-0 tw:leading-none">
        {title}
      </h6>
      <div
        className={`tw:grow tw:border-t tw:border-gray-500 tw:mx-4 ${!manageLabel ? 'tw:mr-0' : ''} tw:self-center`}
      />
      <Link
        href={manageHref ? manageHref : '#'}
        className="tw:text-md tw:font-normal tw:text-primary tw:hover:underline tw:leading-none tw:flex tw:items-center"
      >
        {manageLabel}
        {manageLabel && (
          <span className="tw:ml-1" aria-hidden="true">
            &gt;
          </span>
        )}
      </Link>
    </div>
    {children}
  </section>
);

export const RowLoadingSkeleton: React.FC<Omit<RowLayoutProps, 'children'>> = (
  props,
) => (
  <RowLayout {...props}>
    <CardGrid>
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </CardGrid>
  </RowLayout>
);
